import { render, staticRenderFns } from "./textNav.vue?vue&type=template&id=af0d7f36"
import script from "./textNav.vue?vue&type=script&lang=js"
export * from "./textNav.vue?vue&type=script&lang=js"
import style0 from "./textNav.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports